export default __webpack_public_path__ + "static/media/Believer's Boots of the Soaring Heart.b4b8e1be.jpg";